<template>
  <div id="saibamais">
      <Header :home="false" />
      <b-modal
          ref="modalContatoEmpresa"
          size="md"
          scrollable
          id="modal-saibamais"
          ok-title="Prosseguir"
          >
          <p>{{mensagem_modal}}</p>
      </b-modal>
      <!-- <div class="row">
          <div class="col-11 ml-4 mr-4 text-center">
              <br  v-if="mensagem_enviada || mensagem_enviada == null">
              <b-button variant="danger" class="btenv" block v-if="!mensagem_enviada && mensagem_enviada != null">Não foi possivel realizar o contato</b-button>
          </div>
      </div>
      <div class="row">
          <div class="col-11 ml-4 mr-4 text-center">
              <b-button variant="success" class="btenv" block v-if="mensagem_enviada">Contato realizado </b-button>
          </div>
      </div> -->
      <div class="loading-container" v-if="loading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div> 
      <div>
        <div id="saiba-mais">
          <div class="saiba-mais-face">
            <div class="saiba-mais-bg">
              <img src="@/assets/imgs/corporate-businessmen-working-tablet-office.png"/>
            </div>
            <div class="saiba-mais-face-title">
              <div class="bg-blue-text">
                <h2>Ganhe tempo. Diminua custos.</h2>
              </div>
              <div class="bg-blue-text">
                <h2>Facilite a vida do seu cliente.</h2>
              </div>
              <h1>No <b>portal do IEPTB-BR</b> sua empresa pode contar com diversos serviços prestados pelos <b>Cartórios de Protestos</b> de todo Brasil!</h1>
            </div>
            <div class="saiba-mais-form">
              <h3 class="d-sm-none">Preencha o formulário abaixo e receba mais informações em seu e-mail</h3>
              <h3 class="d-none d-sm-block">Para começar, preencha com os dados abaixo</h3>
              <b-form-group class="saiba-mais-field">
                <label for="nome">Nome da empresa*:</label>
                <b-form-input id="nomeEmpresa" v-model="form.nomeEmpresa" placeholder="Nome da empresa" trim></b-form-input>
              </b-form-group>
              <b-form-group class="saiba-mais-field">
                <label for="nome">Nome*:</label>
                <b-form-input id="nome" v-model="form.nome" placeholder="Seu nome completo" trim></b-form-input>
              </b-form-group>
              <b-form-group class="saiba-mais-field">
                <label for="email">Email*:</label>
                <b-form-input id="email" v-model="form.email" placeholder="Seu endereço de e-mail" trim required></b-form-input>
              </b-form-group>
              <b-form-group class="saiba-mais-field">
                <label for="telefone">Telefone*:</label>
                <the-mask
                :mask="['(##) ####-####', '(##) # ####-####']"
                id="telefone"
                v-model="form.telefone"
                placeholder="(DDD)91234-5678"
                class="form-control"
                />
              </b-form-group>
              <!-- <b-form-group class="saiba-mais-field">
                <label for="profissao">Profissão*:</label>
                <b-form-input id="profissao" v-model="form.profissao" placeholder="Sua profissão" trim></b-form-input>
              </b-form-group>
              <b-form-group class="saiba-mais-field">
                <label for="dtNascimento">Data de nascimento:</label>
                <the-mask
                :mask="['##/##/####']"
                id="dtNascimento"
                v-model="form.dtNascimento"
                placeholder="DD/MM/AAAA (opcional)"
                class="form-control"
                />
              </b-form-group> -->
              <b-form-group class="saiba-mais-field saiba-mais-recaptcha">
                <vue-recaptcha
                ref="invisibleRecaptcha"
                @verify="onVerify"
                @expired="onExpired"
                size="visible"
                :sitekey="sitekey">
                </vue-recaptcha>
              </b-form-group>
              <b-form-group class="saiba-mais-field saiba-mais-check">
                <b-form-checkbox
                id="comunicacoesCheck"
                v-model="comunicacoesCheck"
                ><label for="comunicacoesCheck">Eu concordo em receber comunicações.</label></b-form-checkbox>
              </b-form-group>
              <b-alert v-for="erro in errors" fade variant="danger" class="text-center">{{erro}}</b-alert>
              <p>A nossa empresa está comprometida a proteger e respeitar sua privacidade, utilizaremos seus dados apenas para fins de marketing.</p>
              <b-button variant="saiba-mais-enviar" type="submit" @click="enviar" :disabled="!comunicacoesCheck && !loading">Enviar</b-button>
            </div>
          </div>
          <conhecavantagens id="conheca-vantagens" :home="false"/>
          <div class="saiba-mais-conheca-servicos"></div>
        </div>
      </div>
      <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import API from "../services/api";
import conhecavantagens from '../components/conhecavantagens';
import Header from '../components/Header';
import footersite from '../components/footersite';
import footersitemobile from '../components/footersite/index_mobile';
import { TheMask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    Header,
    footersite,
    footersitemobile,
    conhecavantagens,
    TheMask,
    VueRecaptcha
  },
  data() {
    return {
      loading: false,
      erro_envio: false,
      mensagem_modal:'',
      sitekey: process.env.VUE_APP_sitekeyRecaptcha,
      tok: "",
      comunicacoesCheck: false,
      form:{
        email:'',
        nome:'',
        nomeEmpresa:'',
        telefone:'',
        // profissao:''
      },
      state:{
        email:null,
        nome:null,
        nomeEmpresa:null,
        telefone:null,
        // profissao:null,
      },
      errors:[]
    };
  },
  watch:{
    loading(){
      if(this.loading) document.body.classList.add('noscroll');
      else document.body.classList.remove('noscroll');
    }
  },
  methods: {  
    enviar() {
      if(this.comunicacoesCheck){
        let valido = this.validar();
        if(valido){
          const form = this.form;
          const dados = {
            nome_empresa: form.nomeEmpresa,
            nome_contato: form.nome,
            email: form.email,
            telefone: form.telefone
          }
          this.loading = true;
          API.post("contato-empresa", dados).then(res => {
            let responseCode = res.data.code;
            if (responseCode == '200') {
              this.mensagem_modal = res.data.response;
              this.loading = false;
              this.erro_envio = false;
              this.$refs["modalContatoEmpresa"].show();
            } else {
              this.mensagem_modal = res.data.response;
              this.loading = false;
              this.erro_envio = true;
              this.$refs["modalContatoEmpresa"].show();
            }
          }).catch( error => {
            this.mensagem_modal = 'Erro ao enviar formulário.';
            this.loading = false;
            this.erro_envio = true;
            this.$refs["modalContatoEmpresa"].show();
          });
        }
      }
    },
    validar() {
      this.errors = [];
      Object.entries(this.form).map(campos => {
          let key = campos[0];
          let state = (this.form[key] != null && this.form[key].length > 0);
          this.state[key] = this.isValid(key,state);
      });
      return (this.errors.length == 0);
    },
    isValid(field,state){
      if (!state){
       document.getElementById(field).parentNode.parentNode.classList.add("is-invalid");
       switch (field) {
          case 'email': this.errors.push('Campo Email é obrigatório'); break;
          case 'nome': this.errors.push('Campo Nome é obrigatório'); break;
          case 'nomeEmpresa': this.errors.push('Campo Nome da empresa é obrigatório'); break;
          case 'telefone': this.errors.push('Campo Telefone é obrigatório'); break;
          // case 'profissao': this.errors.push('Campo Profissão é Obrigatório'); break;
        }
      }
      else document.getElementById(field).parentNode.parentNode.classList.remove("is-invalid");
      return state;
    },
    onVerify: function (response) {
      this.tok = response
      // this.$refs.invisibleRecaptcha.reset();
    },
    onExpired: function () {
      this.$refs.invisibleRecaptcha.reset()
    },
    resetRecaptcha () {
      this.$refs.invisibleRecaptcha.reset()
    },
  },
  mounted() {},
}
</script>

<style scoped>
  #saiba-mais{margin: 0 auto;margin: 120px 0 37px 0;width: 100%;display: flex;flex-flow: column;overflow: overlay;}
      #saiba-mais .saiba-mais-face{display: flex;justify-content: center;width:100%;height: 775px;}
        #saiba-mais .saiba-mais-face .saiba-mais-face-title{width: 482px;height: 775px;display: flex;flex-flow: column;justify-content: center;align-items: end;margin-top: -22px;padding-right: 64px;padding-left: 56px;}
          #saiba-mais .saiba-mais-face .saiba-mais-face-title h1{text-align: right;letter-spacing: 0px;color: #FFFFFF;font: normal normal normal 25px/41px 'Kanit', sans-serif;margin-right: 6px;}
          #saiba-mais .saiba-mais-face .saiba-mais-face-title .bg-blue-text {background: #4780F1 0% 0% no-repeat padding-box;padding: 7.5px 6px;margin-bottom: 6px;}
          #saiba-mais .saiba-mais-face .saiba-mais-face-title h2{text-align: right;font: normal normal normal 18px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #FFFFFF;margin:0;}
        #saiba-mais .saiba-mais-face .saiba-mais-form {width: 481px;height: 775px;padding:24px 36px 0 36px;background: #FFFFFF 0% 0% no-repeat padding-box;}
        #saiba-mais .saiba-mais-face .saiba-mais-form h3{width:318px;text-align: center;font: normal normal bold 18px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin:0 auto;margin-bottom: 15px;}
        #saiba-mais .saiba-mais-face .saiba-mais-form p{font: normal normal normal 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #A8A8A8;margin-bottom: 35px;}
        #saiba-mais .saiba-mais-face .saiba-mais-form button.btn-saiba-mais-enviar{width: 100%;height: 45px;background: #4780F1 0% 0% no-repeat padding-box;border-radius: 5px;text-align: center;font: normal normal bold 15px/32px 'Kanit', sans-serif; letter-spacing: 0px;color: #FFFFFF;}
          #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field {margin-bottom: 20px;}
          #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field.saiba-mais-recaptcha {padding-top: 22px;margin-bottom: 25px;}
          #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field.saiba-mais-check {margin-bottom: 16px;}
          #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field label{font: normal normal normal 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5 !important;margin-bottom: 6px;}
            #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field.is-invalid label {color: #1ACEB5 !important;}
          #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field input {text-align: left;font: normal normal normal 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;background: #F1F1F1 0% 0% no-repeat padding-box;border-radius: 5px;}
            /* #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field input:focus,
            #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field input:active {box-shadow: 0 0 0 0.2rem #70ceb54b;border-color: #1ACEB5;} */
            #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field input::placeholder {color: #A8A8A8;}
            #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field.is-invalid input {border: 1px solid #1ACEB5;}
        #saiba-mais .saiba-mais-bg{z-index: -1;position: absolute;width: 100%;height: 775px;background: linear-gradient(180deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;}
          #saiba-mais .saiba-mais-face .saiba-mais-bg img{width: 100%; height: 100%;mix-blend-mode: multiply;object-fit: cover;}

.loading-container{position: absolute;height: 100vh;width: 100vw;top: 0;left: 0;z-index: 1000;background: #00000070;display: flex;align-items: center;justify-content: center;} 
  .loading-container span{width: 100px;height: 100px;z-index: 999;border: 5px solid currentColor;border-right-color: transparent;color: #527CBC !important;animation: 1.25s linear infinite spinner-border;}
  .loading-container:after {border-radius: 5px;position: absolute;background: white;width: 200px;height: 200px;content: '';z-index: 998;}



@media (max-width:1199px){
  #saiba-mais{margin-top: 68px;margin-bottom: 0;}
  #saiba-mais .saiba-mais-face{height: fit-content;flex-flow: column;align-items: center;justify-content: flex-start;background: linear-gradient(180deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;padding-bottom: 51px;}
  #saiba-mais .saiba-mais-bg{height: calc(100vh - 68px);z-index: 0;}
  #saiba-mais .saiba-mais-face .saiba-mais-bg img{object-fit: cover;}
  #saiba-mais .saiba-mais-face .saiba-mais-face-title{height: calc(100vh - 68px);margin: 0;width: 306px;padding: 0;align-items: center;position: relative;}
  #saiba-mais .saiba-mais-face .saiba-mais-face-title h1{font: normal normal normal 25px/34px 'Kanit', sans-serif;text-align: center;}
  #saiba-mais .saiba-mais-face .saiba-mais-form{margin-top: 46px;padding:18px 24px 18px 18px;height: fit-content;max-width: 481px;width: calc(100vw - 40px);}
  #saiba-mais .saiba-mais-face .saiba-mais-form h3{max-width: 244px;font: normal normal bold 18px/24px 'Kanit', sans-serif;}
  #saiba-mais .saiba-mais-face .saiba-mais-form p{font:normal normal normal 12px/17px 'Kanit', sans-serif;}
  #saiba-mais .saiba-mais-face .saiba-mais-form .saiba-mais-field{margin-bottom: 17px;}
}


</style>